import React, { useRef } from 'react';
import usePageMeta from '../hooks/usePageMeta';
import useScrollReveal from '../hooks/useScrollReveal';
import './ai-cro.css';

import CroHero from '../components/cro/CroHero';
import CroProblems from '../components/cro/CroProblems';
import CroServices from '../components/cro/CroServices';
import EcommServices from '../components/cro/EcommServices';
import CroStepper from '../components/cro/CroStepper';
import CroShowcase from '../components/cro/CroShowcase';
import CroPredictions from '../components/cro/CroPredictions';
import CroCaseStudies from '../components/cro/CroCaseStudies';
import CroStats from '../components/cro/CroStats';
import CroTicker from '../components/cro/CroTicker';
import CroTestimonials from '../components/cro/CroTestimonials';
import CroTips from '../components/cro/CroTips';
import CroCta from '../components/cro/CroCta';

export default function AiCro() {
    const pageRef = useRef(null);

    // Apply Meta Tags
    usePageMeta(
        'AI-Assisted CRO Agency for eCommerce Brands | Spinnennetz',
        'Spinnennetz helps eCommerce brands boost conversion rates with AI-assisted CRO — landing pages, A/B testing sprints, and Shopify/WooCommerce development.',
        '/',
        { "@context": "https://schema.org", "@type": "Organization", "name": "Spinnennetz", "url": "https://thespinnennetz.com", "logo": "https://thespinnennetz.com/spinnennetz-logo.png", "description": "AI-assisted CRO agency helping eCommerce brands boost conversion rates with landing pages, A/B testing sprints, and Shopify/WooCommerce development.", "sameAs": [] }
    );

    // Apply Scroll Reveal Animation Logic
    useScrollReveal(pageRef, '.cro-reveal, .cro-reveal-left, .cro-reveal-right, .cro-reveal-scale');

    return (
        <div className="ai-cro-page" ref={pageRef}>
            <CroHero />
            <CroProblems />
            <CroServices />
            <EcommServices />
            <CroStepper />
            <CroShowcase />
            <CroPredictions />
            <CroCaseStudies />
            <CroStats />
            <CroTicker />
            <CroTestimonials />
            <CroTips />
            <CroCta />
        </div>
    );
}
